<template>
    <div class="container container-fluid">
      <div class="d-flex justify-content-between align-items-center">
        <!-- INPUT PARA BUSCAR -->
        <div class="col-md-3 pt-4">
          <input
            v-model="searchTable"
            type="text"
            class="form-control"
            placeholder="Buscar en la tabla..."
          />
        </div>
      </div>

      <div class="table-container-scrollable-forms my-3">
        <table
          class="table table-striped table-hover table-bordered text-center table-rounded mt-2"
        >
          <thead class="table-secondary">
            <tr>
              <th>
                <div class="d-flex justify-content-between align-items-center">
                  <div
                    @click="sortColumn('id')"
                    :class="{
                      'sort-asc': sortOrder.id === 1,
                      'sort-desc': sortOrder.id === -1,
                    }"
                  ></div>
  
                  <div class="mx-auto">ID</div>
                </div>
              </th>
              <th>Apellido</th>
              <th>Nombre</th>
              <th>Dirección</th>
              <th>Celular</th>
              <th>Fecha Solicitud</th>
              <th>Ver PDF</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in filteredData" :key="index">
              <td>{{ row.id }}</td>
              <td>{{ row.last_names }}</td>
              <td>{{ row.first_names }}</td>
              <td>{{ row.address_street }}</td>
              <td>{{ row.cellphone_number }}</td>
              <td>{{ row.fechaFormateada }}</td>
              <td>
                <div
                  title="Ver PDF"
                  class="btn btn-block btn-custom"
                  href="#"
                  @click="formPdf(row.pdf_path)"
                >
                  <i class="bi bi-file-earmark-pdf"></i>
                </div>
                
                <div v-if="row.pdf_img_path"
                  title="Ver PDF Imagenes"
                  class="btn btn-block btn-custom mx-2"
                  href="#"
                  @click="formPdf(row.pdf_img_path)"
                >
                  <i class="bi bi-file-earmark-pdf"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
    </div>
</template>

<script>
import { ref, computed, watch } from "vue";
import apiForms from '../../../apis/Forms'

export default {
  name: "TableCompanies",
  props: {
    dataDATA: Array,
    dataPaginado: Object,
    perPage: Number,
  },
  setup(props, context) {
    const currentPage = ref(1);
    const sortedData = ref([]);
    const searchTable = ref("");
    const totalRecords = ref(props.dataPaginado?.total ?? 0);
    const perPage = ref(props.perPage || 10);

    const sortOrder = ref({
      id: 1,
      name: 1,
    });

    const tableData = ref(props.dataDATA || []);

    const formatFecha = (createdAt) => {
      const [year, month, day] = createdAt.split('T')[0].split('-');
      return createdAt = `${day}-${month}-${year}`;
    };

    const filteredData = computed(() => {
      const search = searchTable.value.toLowerCase();
      return tableData.value.map((row) => {
        const formattedDate = formatFecha(row.createdAt);
        row.fechaFormateada = formattedDate;
        return row;
      }).filter((row) => {
        return Object.values(row)
          .filter((value) => value !== null && value !== undefined)
          .some((value) => value.toString().toLowerCase().includes(search));
      });
    });

    watch(
      () => props.perPage,
      (newPerPage) => {
        perPage.value = newPerPage;
      }
    );

    watch(
      () => props.dataDATA,
      (newData) => {
        tableData.value = [...newData];
      }
    );

    const totalPages = computed(() => {
      return props.dataPaginado ? props.dataPaginado.total_pages : 0;
    });

    const sortColumn = (column) => {
      sortOrder.value[column] = -sortOrder.value[column];
      tableData.value.sort((a, b) => {
        return (a[column] > b[column] ? 1 : -1) * sortOrder.value[column];
      });
    };

    const changePage = (page) => {
      currentPage.value = page;
      context.emit("pageChanged", page);
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value -= 1;
        context.emit('pageChanged', currentPage.value);
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value += 1;
        context.emit('pageChanged', currentPage.value);
      }
    };

    const displayedPages = computed(() => {
      const totalVisiblePages = 5;
      const startPage = Math.max(1, currentPage.value - Math.floor(totalVisiblePages / 2));
      const endPage = Math.min(totalPages.value, startPage + totalVisiblePages - 1);

      let pagesArray = [];
      for (let i = startPage; i <= endPage; i++) {
        pagesArray.push(i);
      }
      return pagesArray;
    });

    const formPdf = async (pdfPath) => {

      try {
        const response = await apiForms.getFormPdf({pdfPath});

        if (response.headers['content-type'] === 'application/pdf') {
 
          const blob = new Blob([response.data], { type: 'application/pdf' });

          const url = window.URL.createObjectURL(blob);

          window.open(url, '_blank');

          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 180000);
          
        } else {
          console.error('La respuesta no es un PDF válido.');
        }
      } catch (error) {
        console.error(error);
      }
    }

    return {
      filteredData,
      displayedPages,
      tableData,
      totalRecords,
      formPdf,
      currentPage,
      sortedData,
      searchTable,
      sortOrder,
      totalPages,
      sortColumn,
      changePage,
      prevPage,
      nextPage,
    };
  },
};
</script>
